module.exports = __webpack_public_path__ + "static/media/icon-webchat.7bc92993.svg";